import { ImageGroup } from '../interfaces/image.interface';
import { GroupTimeAssignment } from '../interfaces/time.interface';

import audio from '../assets/sound/Pegamas.mp3';

const a622: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00622.png';
const a623: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00623.png';
const a624: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00624.png';
const a625: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00625.png';
const a626: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00626.png';
const a627: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00627.png';
const a628: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00628.png';
const a629: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00629.png';
const a630: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00630.png';
const a631: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00631.png';
const a632: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00632.png';
const a633: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00633.png';
const a634: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00634.png';
const a635: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00635.png';
const a636: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00636.png';
const a637: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00637.png';
const a638: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00638.png';
const a639: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00639.png';
const a640: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00640.png';
const a641: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00641.png';
const a642: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00642.png';
const a643: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00643.png';
const a644: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00644.png';
const a645: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00645.png';
const a646: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00646.png';
const a647: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/orange/Particles_00647.png';

const g622: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00622.png';
const g623: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00623.png';
const g624: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00624.png';
const g625: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00625.png';
const g626: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00626.png';
const g627: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00627.png';
const g628: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00628.png';
const g629: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00629.png';
const g630: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00630.png';
const g631: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00631.png';
const g632: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00632.png';
const g633: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00633.png';
const g634: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00634.png';
const g635: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00635.png';
const g636: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00636.png';
const g637: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00637.png';
const g638: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00638.png';
const g639: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00639.png';
const g640: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00640.png';
const g641: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00641.png';
const g642: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00642.png';
const g643: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00643.png';
const g644: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00644.png';
const g645: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00645.png';
const g646: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00646.png';
const g647: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/green/Particles_00647.png';

const b622: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00622.png';
const b623: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00623.png';
const b624: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00624.png';
const b625: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00625.png';
const b626: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00626.png';
const b627: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00627.png';
const b628: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00628.png';
const b629: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00629.png';
const b630: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00630.png';
const b631: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00631.png';
const b632: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00632.png';
const b633: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00633.png';
const b634: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00634.png';
const b635: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00635.png';
const b636: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00636.png';
const b637: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00637.png';
const b638: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00638.png';
const b639: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00639.png';
const b640: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00640.png';
const b641: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00641.png';
const b642: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00642.png';
const b643: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00643.png';
const b644: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00644.png';
const b645: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00645.png';
const b646: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00646.png';
const b647: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/blue/Particles_00647.png';


export const videoUrls = {
  hd: 'https://lotteryblob.blob.core.windows.net/lottery-files/results-sd.webm',
  sd: 'https://lotteryblob.blob.core.windows.net/lottery-files/results-sd.webm',
  low: 'https://lotteryblob.blob.core.windows.net/lottery-files/results-low.webm',
};

export const audioUrl = audio;

export const imageGroups: Record<string, ImageGroup> = {
  orange: {
    images: [
      a622, a623, a624, a625, a626, a627, a628, a629, a630, a631, a632, a633,
      a634, a635, a636, a637, a638, a639, a640, a641, a642, a643, a644, a645,
      a646, a647
    ]
  },
  green: {
    images: [
      g622, g623, g624, g625, g626, g627, g628, g629, g630, g631, g632, g633,
      g634, g635, g636, g637, g638, g639, g640, g641, g642, g643, g644, g645,
      g646, g647
    ]
  },
  blue: {
    images: [
      b622, b623, b624, b625, b626, b627, b628, b629, b630, b631, b632, b633,
      b634, b635, b636, b637, b638, b639, b640, b641, b642, b643, b644, b645,
      b646, b647
    ]
  }
};

export const groupedImageTimings: GroupTimeAssignment[] = [
  { group: 'blue', timeConfig: { start: 26, end: 27.05 } },
  { group: 'blue', timeConfig: { start: 27.71, end: 28.73 } },
  { group: 'orange', timeConfig: { start: 29.43, end: 30.39 } },
  { group: 'orange', timeConfig: { start: 31.13, end: 32.19 } },
  { group: 'green', timeConfig: { start: 32.85, end: 35.15 } },
];
